<div class="fonts">
    <div class="row container-fluid overall-margin">
        <div class="col-md-12 fontFamily-margin">
            <div class="col-md-12 col-xs-12 col-sm-12 heading" style="display:inline-flex">
                <div class="col-9 p-0">
                    <span class="span-budget-actuals color">Budget - Planned vs Spent</span>
                    <span class="pt-2" *ngIf="(this.adminId==1 || this.adminId=='1')" style="font-size: 13px;"><a
                            href="assets/userguides/ERG_UG_Actuals_SuperAdmin.pdf" download
                            class="pl-3 download-link">User
                            Guide</a></span>
                    <span class="pt-2"
                        *ngIf="(this.adminId==2 || this.adminId=='2' || this.adminId==3 || this.adminId=='3')"
                        style="font-size: 13px;"><a href="assets/userguides/ERG_UG_Actuals_ChapterAdmin.pdf" download
                            class="pl-3 download-link">User Guide</a></span>
                    <span class="span-budget-actuals color" style="font-size: x-small; margin-left: 10px;">(Data last
                        updated on {{lastUpdatedDate}})</span>
                </div>
                <div class="col-3 text-right p-0">
                    <button type="button" class="btn btn-danger btn-style" routerLink="../expense-list">BACK</button>
                </div>
            </div>
            <div class="col-sm-6 col-lg-6 col-md-6 col-xs-6 mt-2 mb-2" style="display:inline-flex;">
                <button class="btn btn-danger col-sm-6 col-md-5 col-lg-4 col-xl-3 m-1 curve-edge button-font"
                    [ngClass]="{'disableSection': !isConsolidatedSelected}" (click)="consolidated();
    dropdown.clearModel();">
                    Dashboard</button>
                <button
                    class="btn btn-danger col-sm-8 col-md-6 col-lg-4 col-xl-4 m-1 curve-edge button-font margin-left"
                    [ngClass]="{'disableSection': !isDetailedBreakdownSelected}"
                    (click)="detailedBreakdown();dropdown.clearModel();">Monthly
                    Breakdown</button>
            </div>
        </div>
        <div class="col-md-12" style="margin-left: 30px;" *ngIf="isConsolidatedSelected && adminId==1">
            <label for="isErgSelected" style="display: flex; align-items: center; " class="curve-edge button-font">
                <input type="radio" style="margin-right:5px" name="isErgSelected" checked
                    (click)="radioChapterSelected()">By Chapter
                <input type="radio" class="radio-input-align radio-input-margin"
                    style="margin-left: 2%;margin-right:5px" name="isErgSelected" (click)="radioErgSelected()"
                    *ngIf="adminId==1"><span *ngIf="adminId==1">By ERG</span>
                <input type="radio" class="radio-input-align radio-input-margin"
                    style="margin-left: 2%;margin-right:5px" name="isErgSelected" (click)="radioSiteSelected()"
                    *ngIf="adminId==1"><span *ngIf="adminId==1">By Site</span>
            </label>
        </div>
        <div class="filterAndTable container-fluid">
            <div class="col-md-12 mt-4" style="display:inline-flex; align-items: center;">
                <div class="col-md-5" style="display:inline-flex;align-items: center;">
                    <div class="col-md-2">
                        <label class="labels">
                            <span
                                *ngIf="(!isSiteSelected && !isErgSelected && isChapterSelected) || isDetailedBreakdownSelected">Chapter</span>
                            <span
                                *ngIf="!isSiteSelected && isErgSelected && !isChapterSelected && !isDetailedBreakdownSelected">ERG</span>
                            <span
                                *ngIf="isSiteSelected && !isErgSelected && !isChapterSelected && !isDetailedBreakdownSelected"
                                style="margin-left: 30px;">Site</span>
                        </label>
                    </div>
                    <div class="col-md-10"
                        *ngIf="(!isSiteSelected && !isErgSelected && isChapterSelected) || isDetailedBreakdownSelected">
                        <ng-select #dropdown placeholder="-- Select All --" class="custom" [items]="chapterList"
                            bindLabel="modChapterName" bindValue="chapterId" [(ngModel)]="selectedChapter"
                            (change)="chapterChange($event)"></ng-select>
                    </div>
                    <div class="col-md-10"
                        *ngIf="!isSiteSelected && isErgSelected && !isChapterSelected && isConsolidatedSelected">
                        <ng-select #dropdown placeholder="-- Select All --" class="custom" [items]="ergList"
                            bindLabel="bpgName" bindValue="bpgId" [(ngModel)]="selectedErg"
                            (change)="ergChange($event)"></ng-select>
                    </div>
                    <div class="col-md-10"
                        *ngIf="isSiteSelected && !isErgSelected && !isChapterSelected && isConsolidatedSelected">
                        <ng-select #dropdown placeholder="-- Select All --" class="custom" [items]="siteList"
                            bindLabel="siteName" bindValue="siteId" [(ngModel)]="selectedSite"
                            (change)="siteChange($event)"></ng-select>
                    </div>
                </div>
                <div class="row offset-1 col-md-6 text-right" style="align-items: center;">
                    <div class="col-md-5" style="align-items: center;">
                        <label class="labels">Fiscal Year</label>
                        <button class="btn btn-danger m-1 curve-edge button-font"
                            [class.active]="fiscalYear !== fyValues[1]"
                            (click)="selectedFY(fyValues[1])">FY{{fyLabels[1]}}</button>
                        <button class="btn btn-danger m-1 curve-edge button-font"
                            [class.active]="fiscalYear !== fyValues[0]"
                            (click)="selectedFY(fyValues[0])">FY{{fyLabels[0]}}</button>
                    </div>
                    <div class="col-md-6" style="align-items: center;">
                        <label class="labels">Quarter</label>
                        <button [class.active]="quarter !== 'Q1'" class="btn btn-danger m-1 curve-edge button-font"
                            (click)="quarterSelected('Q1')">Q1</button>
                        <button [class.active]="quarter !== 'Q2'" class="btn btn-danger m-1 curve-edge button-font"
                            (click)="quarterSelected('Q2')">Q2</button>
                        <button [class.active]="quarter !== 'Q3'" class="btn btn-danger m-1 curve-edge button-font"
                            (click)="quarterSelected('Q3')">Q3</button>
                        <button [class.active]="quarter !== 'Q4'" class="btn btn-danger m-1 curve-edge button-font"
                            (click)="quarterSelected('Q4')">Q4</button>
                    </div>
                    <div style="display:inline-flex; align-items: center;">
                        <span class="download-icon mt-2 color curve-edge button-font"
                            (click)="downloadActualsListAsExcel()"><mat-icon matTooltip="download"
                                style="font-size: 24px !important;">download</mat-icon></span>
                    </div>
                </div>
            </div>

            <!-- table data -->
            <div class="col-md-12">
                <div class="mt-5">
                    <p class="noDataFound text-center color" *ngIf="noDataFound"> No record found ! </p>
                    <div id="tabledemo1" *ngIf="tableShow">
                        <div class="table-container">
                            <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}"
                                class="table table-striped" id="tabledemo">
                                <thead>
                                    <tr class="tr-th" style="text-align: center;">
                                        <th *ngIf="isConsolidatedSelected && !isSiteSelected && !isErgSelected && isChapterSelected"
                                            scope="col">Chapter</th>
                                        <th *ngIf="isConsolidatedSelected && !isSiteSelected && isErgSelected && !isChapterSelected"
                                            scope="col">ERG</th>
                                        <th *ngIf="isConsolidatedSelected && isSiteSelected && !isErgSelected && !isChapterSelected"
                                            scope="col">Site</th>
                                        <th *ngIf="isDetailedBreakdownSelected" scope="col"
                                            style="width: 30%;white-space: nowrap;">Chapter</th>
                                        <th *ngIf="isDetailedBreakdownSelected" scope="col"
                                            style="width: 30%;white-space: nowrap;">WBS code</th>
                                        <th scope="col">Fiscal Year</th>
                                        <th *ngIf="isDetailedBreakdownSelected" scope="col"
                                            style="width: 10%;white-space: nowrap;">Date</th>
                                        <th *ngIf="isConsolidatedSelected" scope="col"
                                            style="width: 12%;text-align: left;">
                                            Annual Plan Approved</th>
                                        <th *ngIf="isConsolidatedSelected" scope="col"
                                            style="width: 12%;text-align: left;">
                                            Budget Approved in ERG Connect</th>
                                        <th *ngIf="isDetailedBreakdownSelected" scope="col" style=" text-align: left;">
                                            Amount</th>
                                        <th *ngIf="isConsolidatedSelected" scope="col"
                                            style="width: 12%;text-align: left;">
                                            SAP Actual</th>
                                        <th *ngIf="isConsolidatedSelected && isErgSelected && adminId === '1'"
                                            scope="col" style="text-align: left;">ERG
                                            Discrepancy</th>
                                        <th *ngIf="isConsolidatedSelected && quarter === '' " scope="col"
                                            style="width: 10%;text-align: left;">Available</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="table-secondary" style="font-weight: bold;"
                                        *ngIf="isErgSelected || isSiteSelected">
                                        <td *ngIf="isConsolidatedSelected" scopeS="col"
                                            style="width: 35%; white-space: nowrap;text-align: center;">
                                            <span>Total</span>
                                        </td>
                                        <td *ngIf="isConsolidatedSelected" scope="col"
                                            style="width: 20%; white-space: nowrap;text-align: center;">
                                            {{total.fiscalQtr}}
                                        </td>
                                        <td *ngIf="isConsolidatedSelected" scope="col"
                                            style="width: 10%; white-space: nowrap;text-align: left;">
                                            {{total.chapterApprovedAmount | currency:'USD'}}</td>
                                        <td *ngIf="isConsolidatedSelected" scope="col"
                                            style="width: 10%; white-space: nowrap;text-align: left;">{{total.budget |
                                            currency:'USD'}}</td>
                                        <td *ngIf="isConsolidatedSelected" scope="col"
                                            style="width: 10%; white-space: nowrap;text-align: left;">{{total.spent |
                                            currency:'USD'}}</td>
                                        <td *ngIf="isConsolidatedSelected && isErgSelected && adminId === '1'"
                                            scope="col" style="width: 15%; white-space: nowrap; text-align: left;">
                                            <div class="actualArrow">
                                                <span class="symbolUp" *ngIf="total.ergDiscrepancy < 0">{{'↑'}}</span>
                                                <span class="symbolDown" *ngIf="total.ergDiscrepancy > 0">{{'↓'}}</span>
                                                ${{((total.ergDiscrepancy > 0 )? total.ergDiscrepancy :
                                                (-1)*total.ergDiscrepancy) | number : '1.2-2'}}
                                            </div>
                                        </td>
                                        <td *ngIf="isConsolidatedSelected && quarter === '' " scope="col"
                                            style="width: 10%; white-space: nowrap;text-align: left;">
                                            <div class="actualArrow">
                                                <span class="symbolUp" *ngIf="total.plannedVsActual < 0">{{'↑'}}</span>
                                                <span class="symbolDown"
                                                    *ngIf="total.plannedVsActual > 0">{{'↓'}}</span>
                                                ${{((total.plannedVsActual > 0)? total.plannedVsActual :
                                                (-1)*total.plannedVsActual) | number : '1.2-2'}}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr style="text-align: center;"
                                        *ngFor="let data of actualsDataList  | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements }">
                                        <td *ngIf="isConsolidatedSelected" scope="col"
                                            style="width: 35%; white-space: nowrap;"><span
                                                class="chapterEllipse">{{data.chapterCombination}}</span></td>
                                        <td *ngIf="isDetailedBreakdownSelected" scope="col"
                                            style="width: 20%; white-space: nowrap;"><span
                                                class="chapterEllipse">{{data.projectLevel03}}</span></td>
                                        <td *ngIf="isDetailedBreakdownSelected" scope="col"
                                            style="width: 20%; white-space: nowrap;">{{data.projectLevel07}}</td>
                                        <td *ngIf="isConsolidatedSelected" scope="col"
                                            style="width: 20%; white-space: nowrap;">{{data.fiscalQtr}}</td>
                                        <td *ngIf="isDetailedBreakdownSelected" scope="col"
                                            style="width: 15%; white-space: nowrap;">{{data.fiscalQtr}}</td>
                                        <td *ngIf="isDetailedBreakdownSelected" scope="col"
                                            style="width: 15%; white-space: nowrap;">{{data.date | date: 'MM-dd-yyyy'}}
                                        </td>
                                        <td *ngIf="isConsolidatedSelected" scope="col"
                                            style="width: 10%; white-space: nowrap;text-align: left;">
                                            {{data.chapterApprovedAmount | currency:'USD'}}</td>
                                        <td *ngIf="isConsolidatedSelected" scope="col"
                                            style="width: 10%; white-space: nowrap;text-align: left;">{{data.budget |
                                            currency:'USD'}}</td>
                                        <td *ngIf="isDetailedBreakdownSelected" scope="col"
                                            style="width: 15%; white-space: nowrap; text-align: left;">{{data.amount |
                                            currency:'USD'}}</td>
                                        <td *ngIf="isConsolidatedSelected" scope="col"
                                            style="width: 10%; white-space: nowrap;text-align: left;">{{data.spent |
                                            currency:'USD'}}</td>
                                        <td *ngIf="isConsolidatedSelected && isErgSelected && adminId === '1'"
                                            scope="col" style="width: 15%; white-space: nowrap; text-align: left;">
                                            <div class="actualArrow">
                                                <span class="symbolUp"
                                                    *ngIf="data.symbolRed && !data.symbolGreen">{{'↑'}}</span>
                                                <span class="symbolDown"
                                                    *ngIf="data.symbolGreen && !data.symbolRed">{{'↓'}}</span>
                                                ${{data.ergDiscrepancy | number : '1.2-2'}}
                                            </div>
                                        </td>
                                        <td *ngIf="isConsolidatedSelected && quarter === '' " scope="col"
                                            style="width: 10%; white-space: nowrap;text-align: left;">
                                            <div class="actualArrow">
                                                <span class="symbolUp"
                                                    *ngIf="data.symbolRed1 && !data.symbolGreen1">{{'↑'}}</span>
                                                <span class="symbolDown"
                                                    *ngIf="data.symbolGreen1 && !data.symbolRed1">{{'↓'}}</span>
                                                ${{data.plannedVsActual | number : '1.2-2'}}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv mb-5">
                            <span>Showing {{currentShowingElements}} of {{numberOfElements}} results</span>
                            <pagination-controls previousLabel="Prev" nextLabel="Next"
                                (pageChange)="pageChanged($event)"></pagination-controls>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>